define('helperEntity-isInPageRange',[],function() {
    'use strict';

    var isInPageRange = function(trainingMap, currentId, startId, endId) {
        if(!trainingMap) return;

        var currentIndex = trainingMap.indexOf(currentId),
            startIndex = trainingMap.indexOf(startId),
            endIndex = trainingMap.indexOf(endId || startId);

        if(isNaN(currentIndex) || isNaN(startIndex)){
            console.warn("currentIndex or startIndex == NaN in currentInRange");
            return null;
        }else{
            return (currentIndex >= startIndex && currentIndex <= endIndex);
        }
    };

    return isInPageRange;
});

